/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { replace } from 'react-router-redux';
import {
  Card,
  Dimmer,
  Grid,
  Icon,
  Label,
  Loader,
  Segment,
  Table,
} from 'semantic-ui-react';
import qs from 'qs';
import PageNav from './PageNav';
import SearchFilter from './SearchFilter';
// import { SelectListMultiple } from './Filters';
import LoadImage from './LoadImage';
import MediaItem from './MediaItem';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import isNumber from '../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../utils/url';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class MediaList extends Component {
  static propTypes = {
    notFoundNode: PropTypes.node,
    onClick: PropTypes.func,
    onCheck: PropTypes.func,
    onViewLarge: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    headerNode: PropTypes.func,
    footerNode: PropTypes.func,
    buttonNode: PropTypes.func,
    projectID: PropTypes.string,
    unitLayoutID: PropTypes.string,
    where: PropTypes.shape({}),
    toggleable: PropTypes.bool,
    t: PropTypes.func,
    view: PropTypes.oneOf(['list', 'card']),
    searchRightNav: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static defaultProps = {
    notFoundNode: 'No videos found',
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    // let advanceFilter = false;
    const isMobile = window.innerWidth < 768;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    // const types = query.types || [];
    // if (
    //     (types && types.length > 0)
    //   ) {
    //   advanceFilter = true;
    // }
    return {
      // advanceFilter,
      isMobile,
      currentPage,
      search,
      // types,
    };
  }
  constructor(props) {
    super(props);
    const state = MediaList.getPropsToState(props);
    const view = props.view || 'list';
    this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view,
      ...state,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = MediaList.getPropsToState(nextProps);
    if (nextProps.view) {
      if (this.state.view !== nextProps.view) {
        state.view = nextProps.view;
      }
    }
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getThumbnailUrl = (media) => {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  }
  setData = (data = []) => new Promise((res) => {
    this.setState({
      data: data || [],
    }, () => {
      res(data);
      if (this.props.onChange) {
        this.props.onChange(this.state.data);
      }
    });
  });
  setComponentState = (state = {}) => new Promise((res) => {
    this.setState(state, () => {
      res(state);
    });
  });
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  });
  fetchMedias = async (q = {}) => {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});

    // TODO: hardcode query, to be change
    query.type = 'video';
    query.oembed = true;

    const projectURL = this.props.projectID ? `/projects/${this.props.projectID}` : '';
    const layoutURL = this.props.unitLayoutID ? `/unit_layouts/${this.props.unitLayoutID}` : '';
    const url = projectURL.concat(layoutURL, `/medias/?${qs.stringify(query)}`);
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setData(data);
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    this.fetchMedias(queryNew);
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  handleRefetch() {
    const query = decodeSearch(this.props.location.search);
    this.replaceQuery(query);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleOnClick = (e, media) => {
    if (this.props.onClick) {
      this.props.onClick(e, media);
    }
  }
  handleToggleView = (e) => {
    e.preventDefault();
    const view = this.state.view === 'list' ? 'card' : 'list';
    this.setState({ view });
  }
  handleOnCheck = (media) => {
    if (this.props.onCheck) {
      return this.props.onCheck({ media });
    }
    return false;
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleViewLarge = (e, media) => {
    if (this.props.onViewLarge) {
      this.props.onViewLarge(e, media);
    }
  }
  handleOnRemove = (e, media) => {
    if (this.props.onRemove) {
      this.props.onRemove(e, media);
    }
  }
  renderType(media) {
    let pictureType = media.type;
    if (this.props.unitLayoutID && media.unitLayouts && media.unitLayouts.length > 0) {
      pictureType = media.unitLayouts.find(ul =>
        ul.projectUnitLayoutID === this.props.unitLayoutID).type;
    } else if (this.props.projectID && media.projects && media.projects.length > 0) {
      pictureType = media.projects.find(p => p.projectID === this.props.projectID).type;
    }
    return pictureType.replace('_', ' ');
  }
  renderLabel = (media) => {
    if (media.label && media.label.trim().length > 0) {
      return media.label;
    }
    if (this.state.isMobile) {
      return <span className="grey-text">No label set</span>;
    }
    return '-';
  }
  renderBody() {
    const { t } = this.props;
    if (this.state.view === 'list') {
      return (
        this.state.data.length > 0 ?
        this.state.data.map((media, key) => {
          const thumbnailUrl = this.getThumbnailUrl(media);
          return (
            <Table.Row
              key={key}
              disabled={this.handleOnCheck(media)}
              onClick={e => this.handleOnClick(e, media)}
            >
              {
                !this.state.isMobile && (
                  <Table.Cell width={3}>
                    <LoadImage
                      as="a"
                      centered
                      size="small"
                      src={thumbnailUrl}
                      onClick={e => this.handleViewLarge(e, media)}
                      isVideo
                    />
                  </Table.Cell>
                )
              }
              <Table.Cell
                width={this.state.isMobile ? 16 : 6}
              >
                {
                  this.state.isMobile ? (
                    <Grid columns="equal">
                      <Grid.Column width={6}>
                        <LoadImage
                          as="a"
                          centered
                          size="tiny"
                          src={thumbnailUrl}
                          onClick={e => this.handleViewLarge(e, media)}
                          isVideo
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Grid columns="equal">
                          <Grid.Row>
                            <Grid.Column width={16}>
                              {this.renderLabel(media)}
                              <p>
                                <small>
                                  <Link
                                    as="a"
                                    to={media.url}
                                    target="_blank"
                                  >
                                    <Icon
                                      style={{ marginRight: '0.5em' }}
                                      size="small"
                                      name="external"
                                    />
                                    {media.url}
                                  </Link>
                                </small>
                              </p>
                            </Grid.Column>
                          </Grid.Row>
                          {this.props.buttonNode ? (
                            <Grid.Row>
                              <Grid.Column width={16} textAlign="right">
                                {this.props.buttonNode({
                                  loading: this.state.loading,
                                  item: media,
                                  view: this.state.view,
                                  isMobile: this.state.isMobile,
                                })}
                              </Grid.Column>
                            </Grid.Row>
                          ) : null}
                        </Grid>
                      </Grid.Column>
                    </Grid>
                  ) : (
                    <div>
                      {this.renderLabel(media)}
                      <p>
                        <small>
                          <Link
                            as="a"
                            to={media.url}
                            target="_blank"
                          >
                            <Icon
                              style={{ marginRight: '0.5em' }}
                              size="small"
                              name="external"
                            />
                            {media.url}
                          </Link>
                        </small>
                      </p>
                    </div>
                  )
                }
              </Table.Cell>
              {!this.state.isMobile &&
                <Table.Cell>
                  {this.props.buttonNode ? (
                    <div className="picture-list-buttons">
                      {this.props.buttonNode({
                        loading: this.state.loading,
                        item: media,
                        view: this.state.view,
                        isMobile: this.state.isMobile,
                      })}
                    </div>
                  ) : null}
                </Table.Cell>}
            </Table.Row>
          );
        }) : (
          <Table.Row>
            <Table.Cell colSpan="100%" textAlign="center">
              {
                this.state.loading ? <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                : this.props.notFoundNode ? t(this.props.notFoundNode, { ns: TRANSLATION_FILES.translation }) : null
              }
            </Table.Cell>
          </Table.Row>
        )
      );
    }
    return (
      <Table.Row>
        <Table.Cell>
          <Card.Group itemsPerRow={this.state.data.length > 0 ? 4 : 1} doubling stackable>
            {
              this.state.data.length > 0 ?
              this.state.data.map((media, key) => (
                <MediaItem
                  key={key}
                  media={media}
                  size="medium"
                  onViewLarge={e => this.handleViewLarge(e, media)}
                  onRemove={e => this.handleOnRemove(e, media)}
                  buttonNode={this.props.buttonNode ?
                    this.props.buttonNode({
                      loading: this.state.loading,
                      item: media,
                      view: this.state.view,
                      isMobile: this.state.isMobile,
                    }) : null
                  }
                  // labelNode={
                  //   <Label
                  //     className="capitalize"
                  //     attached="top left"
                  //     content={this.renderType(media)}
                  //   />
                  // }
                />
              )) : (
                <Card>
                  <Segment textAlign="center" vertical>
                    {
                      this.state.loading ? <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                      : this.props.notFoundNode ? t(this.props.notFoundNode, { ns: TRANSLATION_FILES.translation }) : null
                    }
                  </Segment>
                </Card>
              )
            }
          </Card.Group>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const { t } = this.props;
    const {
      count, limit, offset, data, loading, currentPage, view,
    } = this.state;
    return (
      <div>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Table
          fixed={view === 'card'}
          striped unstackable
        >
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="100%">
                <Grid columns={1} verticalAlign="middle">
                  {
                    this.props.toggleable &&
                    <Grid.Column>
                      <Label
                        as="button"
                        attached="top left"
                        size="small"
                        icon={`${view === 'list' ? 'block' : 'list'} layout`}
                        content={t(view === 'list' ? 'Card' : 'List', { ns: TRANSLATION_FILES.screens })}
                        onClick={this.handleToggleView}
                        disabled={this.state.loading}
                      />
                    </Grid.Column>
                  }
                  <Grid.Column>
                    {
                      this.props.headerNode ?
                      this.props.headerNode({
                        count,
                        limit,
                        offset,
                        dataSize: data.length,
                        loading,
                        currentPage,
                        onChange: this.handleChangePage,
                      }) : (
                        <SearchFilter
                          inTable
                          advanceFilter={this.state.advanceFilter}
                          isLoading={loading}
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          search={this.state.search}
                          setAdvanceFilter={this.handleSetAdvanceFilter}
                          leftNav={(
                            <PageNav
                              currentPage={currentPage}
                              count={count}
                              limit={limit}
                              offset={offset}
                              dataSize={data.length}
                              loading={loading}
                              onChange={this.handleChangePage}
                            />
                          )}
                          rightNav={this.props.searchRightNav}
                        />
                      )
                    }
                  </Grid.Column>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
            {
              view === 'list' &&
              !this.state.isMobile &&
              <Table.Row>
                <Table.HeaderCell>{t('Preview', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                <Table.HeaderCell>{t('Label | URL', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            }
          </Table.Header>
          <Table.Body>
            {this.renderBody()}
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="100%">
                {
                  this.props.footerNode ?
                  this.props.footerNode({
                    count,
                    limit,
                    offset,
                    dataSize: data.length,
                    loading,
                    currentPage,
                    onChange: this.handleChangePage,
                  }) : (
                    <Grid columns="equal" verticalAlign="middle">
                      <Grid.Column>
                        <PageNav
                          upward
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={data.length}
                          loading={loading}
                          onChange={this.handleChangePage}
                        />
                      </Grid.Column>
                    </Grid>
                  )
                }
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(withRouter(MediaList, { withRef: true }));



// WEBPACK FOOTER //
// ./src/components/MediaList.jsx